import axios, { AxiosInstance, AxiosRequestConfig } from "axios"
import { IRequestQrCodeParams, IRequestSendByEmailParams, IRewardProvider } from "../../domain/providers/IRewardProvider"
import routes from "./routes"

class RewardProvider implements IRewardProvider {
    public http: AxiosInstance

    constructor(baseURL: string) {
        const config: AxiosRequestConfig = {
            baseURL: `${baseURL}/api/v1`,
            headers: {
                'content-type': 'application/json'
            }
        }
        this.http = axios.create(config)
    }

    async requestQrCode(param: IRequestQrCodeParams): Promise<string> {
        const { data } = await this.http.get(routes.GET_QR_CODE.replace('<store_id>', param.dropoffId).replace('<email>', param.email))
        return data
    }

    async requestSendByEmail(param: IRequestSendByEmailParams): Promise<void> {
        return this.http.post(routes.SEND_CODE_BY_EMAIL.replace('<store_id>', param.dropoffId), {
            contributorEmail: param.email
        })
    }
}

export default RewardProvider
